module.exports = __webpack_public_path__ + "static/media/sa.c36d1991.svg";